const LOBBY_SCREEN = 1
const RULE_SCREEN = 2
const COUNTDOWN_5S_SCREEN = 3
const QUESTION_SCREEN = 4
const RESULT_SCREEN = 5

export default {
  LOBBY_SCREEN,
  RULE_SCREEN,
  COUNTDOWN_5S_SCREEN,
  QUESTION_SCREEN,
  RESULT_SCREEN,
}
